import { injectable } from "inversify";
import RoleEntity from "../../entities/RoleEntity";
import ExceptionEntity from "../../entities/ExceptionEntity";
import { Either } from "fp-ts/lib/Either";
import RoleRepository from "../../repositories/RoleRepository";

interface props { roleRepository: RoleRepository }

@injectable()
export default class UpdateRoleUseCase {
    _roleRepository: RoleRepository;

    constructor(_: props) {
        this._roleRepository = _.roleRepository;
    }

    public call = (id: string, name: string, description: string) => new  Promise<Either<ExceptionEntity, string>>(async (resolve, reject) => {
        try {
            const response = await this._roleRepository.updateRoleInfo(id, name, description);
            
            return resolve(response);
        } catch (error) {
            return reject();
        }
    });
};

export const UpdateRoleUseCaseCaseName = "UpdateRoleUseCaseCaseName";